var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDeleteAccount = function SvgIconDeleteAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_delete_account_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_delete_account_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C6A6B",
    d: "m9.4 16.154 2.6-2.6 2.6 2.6 1.054-1.054-2.6-2.6 2.6-2.6L14.6 8.846l-2.6 2.6-2.6-2.6L8.346 9.9l2.6 2.6-2.6 2.6zM7.308 20.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6h-1V4.5H9v-.884h6V4.5h4.5V6h-1v12.692q0 .758-.525 1.283t-1.283.525zM17 6H7v12.692q0 .116.096.212a.3.3 0 0 0 .212.096h9.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212z"
  }))));
};
export default SvgIconDeleteAccount;